import {
    GET_COMPANY_DETAILS_LIST_PROGRESS, GET_COMPANY_DETAILS_LIST_SUCCESS, GET_COMPANY_DETAILS_LIST_FAILURE,
    ADD_COMPANY_DETAILS_PROGRESS, ADD_COMPANY_DETAILS_SUCCESS, ADD_COMPANY_DETAILS_FAILURE,
    EDIT_DELETE_COMPANY_DETAILS_PROGRESS, EDIT_DELETE_COMPANY_DETAILS_SUCCESS, EDIT_DELETE_COMPANY_DETAILS_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    company: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const company_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_COMPANY_DETAILS_LIST_SUCCESS:
            return { ...state, company: action.company, loading: false };
        case GET_COMPANY_DETAILS_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_COMPANY_DETAILS_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_COMPANY_DETAILS_PROGRESS:
            return { ...state, loading: true };
        case ADD_COMPANY_DETAILS_SUCCESS:
            return { ...state, company: [...state.company, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_COMPANY_DETAILS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_COMPANY_DETAILS_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_COMPANY_DETAILS_SUCCESS:
            return {
                ...state,
                company: state.company.map((company) =>
                company.id === action.payload.id ? action.payload : company
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_COMPANY_DETAILS_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default company_reducer;